export * from './mobile-fitter-openings-page.component';
